module.exports = __webpack_public_path__ + "img/FI_IA.7b44fc82.png";